import { render, staticRenderFns } from "./privatizationDetail.vue?vue&type=template&id=4ed638ec&scoped=true"
import script from "./privatizationDetail.vue?vue&type=script&lang=ts"
export * from "./privatizationDetail.vue?vue&type=script&lang=ts"
import style0 from "./privatizationDetail.vue?vue&type=style&index=0&id=4ed638ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed638ec",
  null
  
)

export default component.exports